var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"aa013fd1b925da9d21e43653e478cdae42a94742"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["lacinetek-frontend@codekraft-ka"]={id:"aa013fd1b925da9d21e43653e478cdae42a94742"};
      